"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.THE_GRAPH_ORDERS_API = exports.SQUIGLE = void 0;
var web3_candies_1 = require("@defi.org/web3-candies");
exports.SQUIGLE = "≈";
exports.THE_GRAPH_ORDERS_API = (_a = {},
    _a[web3_candies_1.networks.bsc.id] = "https://hub.orbs.network/api/apikey/subgraphs/id/4NfXEi8rreQsnAr4aJ45RLCKgnjcWX46Lbt9SadiCcz6",
    _a[web3_candies_1.networks.poly.id] = "https://hub.orbs.network/api/apikey/subgraphs/id/3PyRPWSvDnMowGbeBy7aNsvUkD5ZuxdXQw2RdJq4NdXi",
    _a[web3_candies_1.networks.arb.id] = "https://hub.orbs.network/api/apikey/subgraphs/id/83bpQexEaqBjHaQbKoFTbtvCXuo5RudRkfLgtRUYqo2c",
    _a[web3_candies_1.networks.base.id] = "https://hub.orbs.network/api/apikey/subgraphs/id/DFhaPQb3HATXkpsWNZw3gydYHehLBVEDiSk4iBdZJyps",
    _a[web3_candies_1.networks.eth.id] = "https://hub.orbs.network/api/apikey/subgraphs/id/Bf7bvMYcJbDAvYWJmhMpHZ4cpFjqzkhK6GXXEpnPRq6",
    _a);
